import { useState, useEffect } from "react";
import { useFirestore } from "../../hooks/useFirestore";
import data from "../../EE_courses.json";
import { MdDeleteForever } from "react-icons/md";
import {
  Badge,
  Button,
  Card,
  CloseButton,
  Col,
  Container,
  Form,
  Modal,
  Row,
} from "react-bootstrap";

export default function StudentForm({ uid, students }) {
  const [subjectsToAdd, setSubjectsToAdd] = useState([]);
  const [subjectsToDrop, setSubjectsToDrop] = useState([]);
  const [notes, setNotes] = useState("");
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirm, setConfirm] = useState(false);

  const documents = data;
  const { updateDocument, response } = useFirestore("students");

  const handleSubmit = (e) => {
    e.preventDefault();
    setConfirmationModal(true);
  };

  const handleDeleteAddedSubject = (index) => {
    setSubjectsToAdd((prevSubjects) =>
      prevSubjects.filter((subject, i) => i !== index)
    );
  };

  const handleDeleteDroppedSubject = (index) => {
    setSubjectsToDrop((prevSubjects) =>
      prevSubjects.filter((subject, i) => i !== index)
    );
  };
  const handleSubjectsToAdd = (e) => {
    const selectedSubject = e.target.value;
    if (selectedSubject === "") {
      return;
    }
    if (subjectsToAdd.includes(selectedSubject)) {
      alert("لقد قمت باختيار هذا المقرر بالفعل");
      return;
    }
    if (subjectsToAdd.length >= 8) {
      alert(
        "بامكانك الاختيار الى  8 مواد, يرجى اضافة اي مادة اخرى بصندوق الملاحظات"
      );
      return;
    }
    setSubjectsToAdd((prevSubjects) => [...prevSubjects, selectedSubject]);
  };

  const handleSubjectsToDrop = (e) => {
    const selectedSubject = e.target.value;
    if (selectedSubject === "") {
      return;
    }
    if (subjectsToDrop.includes(selectedSubject)) {
      alert("لقد قمت باختيار هذا المقرر بالفعل");
      return;
    }
    if (subjectsToDrop.length >= 8) {
      alert(
        "بامكانك الاختيار الى  8 مواد, يرجى اضافة اي مادة اخرى بصندوق الملاحظات"
      );
      return;
    }
    setSubjectsToDrop((prevSubjects) => [...prevSubjects, selectedSubject]);
  };

  useEffect(() => {
    if (confirm) {
      updateDocument(uid, {
        subjects_to_add: subjectsToAdd,
        subjects_to_drop: subjectsToDrop,
        notesToSupervisor: notes,
      });
    }
  }, [confirm, subjectsToDrop, subjectsToAdd]);

  // reset the form fields
  useEffect(() => {
    if (response.success) {
      setSubjectsToAdd([]);
      setSubjectsToDrop([]);
    }
  }, [response.success]);

  return (
    <>
      <Card className="student-form" style={{ marginBottom: "2.5rem" }}>
        <Card.Body>
        <Button
          variant="success"
          style={{ 
            marginTop: "1.5rem",
            marginBottom: "1.5rem",
            color: "white",
            width: "100%"
        }}
              onClick={() => {
                const studentLinks = students?.map(student => student.form_link.replace("/preview", ""));
                if (studentLinks.length > 0) {
                  window.open(studentLinks[0], '_blank');
                }
              }}
          >
            تنزيل الاستمارة
      </Button>


          <Form onSubmit={handleSubmit}>
            <div className="form-group">
              <label style={{ color: "white" }}>
                <h5 style={{display: 'inline'}}>  <span style={{color: '#00FF00'}}>اضافة</span> مواد  </h5> <span style={{color: '#d5d5d5!important'}} className="text-muted"> [اختر اكثر من مادة بالضغط على نفس الصندوق]</span> 
              </label>
              <select
                style={{ marginBottom: "10px" }}
                className="form-control"
                onChange={handleSubjectsToAdd}
                value=""
              >
                <option value="" disabled>
                  -- اختر مادة --
                </option>
                {documents.map((course) => (
                  <option key={course.course_id} value={course.course_id}>
                    {course.course_title} | {course.course_id}
                  </option>
                ))}
              </select>
            </div>
            {subjectsToAdd.length > 0 && (
              <div className="form-group">
                <label style={{ marginBottom: "12px", color: "white" }}>
                  المواد المختارة :
                </label>

                <div className="d-flex flex-wrap">
                  {subjectsToAdd.map((subject, index) => (
                    <div
                      style={{ alignItems: "center", gap: "5px" }}
                      className="badge bg-primary d-flex me-1 mb-1"
                    >
                      <span> {subject} </span>

                      <CloseButton
                        style={{ width: "1px" }}
                        variant="white"
                        onClick={() => handleDeleteAddedSubject(index)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="form-group">
              <label style={{ marginTop: "12px", color: "white" }}>
                <h5 style={{    display: 'inline'}}> <span style={{ color: "red" }}>اسقاط</span> مواد </h5> 
                <span className="text-muted"> [اختر اكثر من مادة بالضغط على نفس الصندوق]</span> 
              </label>
              <select
                style={{ marginBottom: "10px" }}
                className="form-control"
                onChange={handleSubjectsToDrop}
                value=""
              >
                <option value="" disabled>
                  -- اختر مادة --
                </option>
                {documents.map((course) => (
                  <option key={course.course_id} value={course.course_id}>
                    {course.course_title} | {course.course_id}
                  </option>
                ))}
              </select>
            </div>
            {subjectsToDrop.length > 0 && (
              <div className="form-group">
                <label style={{ marginBottom: "12px", color: "white" }}>
                  المواد المختارة :
                </label>

                <div className="d-flex flex-wrap">
                  {subjectsToDrop.map((subject, index) => (
                    <div
                      style={{ alignItems: "center", gap: "5px" }}
                      className="badge bg-primary d-flex me-1 mb-1"
                    >
                      <span> {subject} </span>

                      <CloseButton
                        style={{ width: "1px" }}
                        variant="white"
                        onClick={() => handleDeleteDroppedSubject(index)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className="form-group">
              <label
                style={{ marginTop: "12px", color: "white" }}
                htmlFor="notes"
              >
                الملاحظات (اختياري)
              </label>
              <textarea
                className="form-control"
                id="notes"
                onChange={(e) => setNotes(e.target.value)}
                value={notes}
                placeholder="اكتب ملاحظة للمرشد, مثال: مادة غير مكمل, يوجد مادة بالمراجعة.."
              />
            </div>

            <Button
              style={{ marginTop: "1.5rem" }}
              type="submit"
              variant="dark"
              disabled={subjectsToAdd.length === 0 && subjectsToDrop.length === 0}
            >
              ارسال
            </Button>
          </Form>
        </Card.Body>
      </Card>

      <Modal
        className="comment-modal"
        show={confirmationModal}
        onHide={() => setConfirmationModal(false)}
      >
        <Modal.Header>
          <Modal.Title> الرجاء التأكيد</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          هل انت متأكد من <span style={{ color: "#00FF00" }}>اضافة</span> المواد
          التالية: <br />
          {subjectsToAdd.join(", ")} <br />
          هل انت متأكد من <span style={{ color: "red" }}>اسقاط</span> المواد
          التالية: <br />
          {subjectsToDrop.join(", ")} <br />
          {notes && `ملاحظة: ${notes}`}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setConfirmationModal(false)}
          >
            إلغاء
          </Button>
          <Button variant="light" onClick={() => setConfirm(true)}>
            نعم
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

